import * as Sentry from "@sentry/react";
import { Link, useRouteError } from "react-router-dom";
import { t } from "ttag";

import { IS_PRODUCTION } from "@/config/env";
import { FullscreenAlert } from "@/shared/ui";
import { LinkBrokenMinimalisticIcon } from "@/shared/ui/icons/formatting/link";
import { getFaqLink } from "@/shared/utils";

export const ErrorBoundary = () => {
  const error = useRouteError();

  if (IS_PRODUCTION) {
    Sentry.captureException(error, {
      tags: {
        type: "router-error-boundary",
      },
    });
  } else {
    console.info("ERROR:", error);
  }

  const faqLink = getFaqLink();

  return (
    <FullscreenAlert.Root open={true}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header icon={LinkBrokenMinimalisticIcon}>
          <FullscreenAlert.Title>
            {t`Oops! There was an error`}
          </FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`Oops! It looks like there's been a hiccup. Not to worry, though! We've already let our technical support team know, and they'll be reaching out to you with a solution. Thanks for your understanding!`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Cancel
            variant="secondary"
            onClick={() => window.location.reload()}
          >
            {t`Try again`}
          </FullscreenAlert.Cancel>

          <FullscreenAlert.Action asChild>
            <Link to={faqLink}>{t`Contact support`}</Link>
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
